import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { UpdateDataTokenCode } from 'src/app/shared/class/update-data';
import { CreditTypeId } from 'src/app/shared/enums/credit-type.enum';
import { Cause, StepOptionUber } from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step-datos-uber',
  templateUrl: './step-datos-uber.component.html',
  styleUrls: ['./step-datos-uber.component.scss'],
})
export class StepDatosUberComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  @Input() saveRequest!: Observable<boolean>;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepDataUberSavedEvent = new EventEmitter<boolean>();
  public formStepDataUber!: FormGroup;
  protected _onDestroy = new Subject<void>();
  public dataUber!: boolean;
  public referalQr!: string;
  public codeReferral!: string;
  public creditTypeUpdate!: string;
  public enableButtonApproved = false;
  public clicked = false;

  constructor(
    private frmBuilder: FormBuilder,
    private dialog: MatDialog,
    private putDataService: PutDataService,
    private requestFormService: RequestFormService,
    private router: Router,
    private getDataService: GetDataService,
    private activatedRouter: ActivatedRoute
  ) {
    super();

    this.activatedRouter.queryParams.subscribe((params) => {
      this.referalQr = params['referall'];
      this.codeReferral = params['referralCode'];
    });

    this.formStepDataUber = this.frmBuilder.group({
      hasUber: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.accessLoginUber();

    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepDataUber.dirty) {
          this.saveStepDataUber();
        } else {
          this.stepDataUberSavedEvent.emit(true);
        }
      }
    });

    if (
      this.requestFormService.getUpdateForm() &&
      this.getStepNumber() > 2 &&
      this.getCreditType() === CreditTypeId.DAE
    ) {
      this.loadUpdateFormStepAboutYou();
    }

    this.checkEvent();
  }

  checkEvent() {
    if (
      this.requestFormService.getUpdateForm() &&
      this.requestFormService.getUpdateForm().prefilter.hasUberAccount != null
    ) {
      this.formValidEvent.emit(
        this.requestFormService.getUpdateForm().prefilter.hasUberAccount &&
          this.dataUber != false &&
          this.formStepDataUber.valid &&
          this.enableButtonApproved
      );
    } else {
      this.formValidEvent.emit(
        this.dataUber &&
          this.formStepDataUber.valid &&
          this.enableButtonApproved
      );
    }
  }

  getStepDataUberObject(): StepOptionUber {
    return {
      ...this.formStepDataUber.value,
    };
  }

  saveStepDataUber() {
    if (this.formStepDataUber.valid) {
      const putSaveOptionUber$ = this.putDataService
        .putSaveOptionUber(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStepDataUberObject()
        )
        .subscribe({
          error: (err) => {
            this.openDialogValidUber(err);
          },
        });
      this.subscriptions.push(putSaveOptionUber$);

      const putUpdateRequestDataUber$ = this.putDataService
        .putUpdateRequestDataUber(
          this.getCountry().toUpperCase(),
          this.getApplicationId()
        )
        .subscribe((resp) => {
          resp.approved
            ? this.stepDataUberSavedEvent.emit(true)
            : this.openDialogValidUber(resp.causes![0]);
        });
      this.subscriptions.push(putUpdateRequestDataUber$);
    }
  }

  loadUpdateFormStepAboutYou() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.formStepDataUber.patchValue({
      hasUber: value.prefilter.hasUberAccount,
    });
  }

  validInputDataUber({ source }: MatRadioChange) {
    this.dataUber = source.value;

    const dataUberValidators =
      source.value === true ? [Validators.required] : [];

    this.formStepDataUber.controls['hasUber'].setValidators(dataUberValidators);

    this.formStepDataUber.controls['hasUber'].updateValueAndValidity();
  }

  openDialogUber() {
    window.open(`${environment.apiurluber}`, '', 'width=900,height=900');
  }

  openDialogUberCreateAccount() {
    window.open('https://auth.uber.com/v2', '', 'width=900,height=900');
  }

  openDialogValidUber(value: Cause) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorCodeToken = `TOKEN`.match(value.code);
    const errorCodeStatus = `STATUS`.match(value.code);
    const errorCodeDebt = `DEBT`.match(value.code);

    if (errorCodeToken) {
      errorMessage = `Uber nos informa que el token no fue encontrado. Por favor regularice su situación para avanzar.`;
    }
    if (errorCodeStatus) {
      errorMessage = `Uber nos informa que tiene un estado distinto a Activo. Por favor regularice su situación para avanzar.`;
    }
    if (errorCodeDebt) {
      errorMessage = `Uber nos informa que tiene deuda. Por favor regularice su situación para avanzar.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getCreditType() {
    if (this.requestFormService.getUpdateForm()) {
      this.creditTypeUpdate =
        this.requestFormService.getUpdateForm().creditType.code === 'DAE'
          ? '9'
          : '1';
    }
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('creditType')!
      : this.creditTypeUpdate;
  }

  getStepNumber() {
    return !this.requestFormService.getUpdateForm()
      ? parseInt(sessionStorage.getItem('stepNumber')!)
      : this.requestFormService.getUpdateForm().lastSectionCompleted;
  }

  accessLoginUber() {
    setTimeout(() => {
      const getConsultLoginUberDae$ = this.getDataService
        .getConsultLoginUberDae(
          this.getCountry().toUpperCase(),
          this.getApplicationId()
        )
        .subscribe((resp) => {
          this.enableButtonApproved = resp.isLogged;
          this.accessLoginUber();
          this.checkEvent();
        });
      this.subscriptions.push(getConsultLoginUberDae$);
    }, 5000);
  }
}
